"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    fullScreenSvgFill: {
        fill: function (data) { return data.color; },
    },
};
//# sourceMappingURL=full-screen.theme.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/playable/dist/src/modules/ui/controls/full-screen/full-screen.theme.js
// module id = 208
// module chunks = 0